// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.reg-field[data-v-170ac9af] input,\n.reg-field[data-v-170ac9af] select {\n\tborder: 1px solid var(--surface-5);\n}\n.reg-field[data-v-170ac9af] input:focus,\n.reg-field[data-v-170ac9af] select:focus {\n\tborder-color: var(--c-main);\n\tbox-shadow: 0 0 0 1px var(--c-main);\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
